import { Dialog } from '@mui/material';
import { Box, Button, Stack, Typography } from '..';
import { styled } from '@mui/system';
import CircularProgress from '../CircularProgress/CircularProgress';
import { ReactNode } from 'react';

interface Props {
  title: string;
  content?: string;
  children?: ReactNode;
  onConfirm: () => void;
  onCancel: () => void;
  open: boolean;
  isLoading?: boolean;
  onConfirmDisabled?: boolean;
}

const CancelButton = styled(Button)(({ theme }) => {
  return {
    backgroundColor: theme.palette.grey[400],
    borderColor: theme.palette.grey[400],

    '&:hover': {
      backgroundColor: theme.palette.grey[500],
      borderColor: theme.palette.grey[500],
      boxShadow: 'none'
    },
    '&:active': {
      boxShadow: 'none',
      backgroundColor: theme.palette.grey[400],
      borderColor: theme.palette.grey[400]
    }
  };
});

export default function Confirm({
  title,
  content,
  children,
  onConfirm,
  onCancel,
  open,
  isLoading = false,
  onConfirmDisabled = false
}: Props) {
  return (
    <Dialog open={open} onClose={onCancel}>
      <Box p={2} display="flex" flexDirection="column" bgcolor="secondary.main" pt={3.5}>
        <Box px={5} sx={{ whiteSpace: 'pre-wrap', textAlign: 'center' }}>
          <Typography fontWeight={600} variant="h6">
            {title}
          </Typography>
        </Box>
        {content && (
          <Box>
            <Typography>{content}</Typography>
          </Box>
        )}
        {children && <>{children}</>}
        <Stack direction="row" flexDirection="row" justifyContent="center" spacing={1} mt={2} mb={1}>
          <CancelButton onClick={onCancel} variant="contained" disabled={isLoading}>
            No
          </CancelButton>
          <Button
            onClick={onConfirm}
            color="primary"
            variant="contained"
            autoFocus={true}
            disabled={isLoading || onConfirmDisabled}
            data-attr="dialog-confirm-button"
          >
            {isLoading ? <CircularProgress sx={{ width: '12px' }} /> : 'Yes'}
          </Button>
        </Stack>
      </Box>
    </Dialog>
  );
}

export { Confirm };
